import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';

import {AuthResponse} from './model/authResponse';
import {Module} from './model/module';
import {ModuleVisibility} from './model/moduleVisibility';
import {AuthService} from './services/auth.service';
import {ModulesService} from './services/modules.service';

@Injectable()
export class ModulesDataManager {
  constructor(private modulesService: ModulesService) {}

  public getAllModules(): Observable<Module[]> {
    return this.modulesService.getAllModules();
  }
  
  public createModule(
      name: string, image_url: string, tincan_url: string,
      visibility: ModuleVisibility[], isExam: boolean): Observable<Module> {
    return this.modulesService.createModulewithObject(
        name, image_url, tincan_url, visibility, isExam);
  }

  public updateOrder(id: string, order: number) {
    return this.modulesService.updateOrder(id, order);
  }

  public updateModuleVisability(id: string, moduleVisability: ModuleVisibility):
      Observable<Module> {
    return this.modulesService.updateModuleVisability(id, moduleVisability);
  }

  public deleteModule(id: string): Observable<Module> {
    return this.modulesService.deleteModule(id);
  }

  public updateModule(module: Module): Observable<Module> {
    return this.modulesService.updateModule(module);
  }
}



// WEBPACK FOOTER //
// /tmp/build_f0fbff5b/src/app/data/modules.datamanager.ts